import { NgModule } from '@angular/core';
import { PrettyJsonComponent } from './prettyjson.component';
import { PrettyJsonPipe } from './prettyjson.pipe';
import { SafeJsonPipe } from './json.pipe';
export var PrettyJsonModule = (function () {
    function PrettyJsonModule() {
    }
    PrettyJsonModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        PrettyJsonComponent,
                        PrettyJsonPipe,
                        SafeJsonPipe
                    ],
                    exports: [
                        PrettyJsonComponent,
                        PrettyJsonPipe,
                        SafeJsonPipe
                    ]
                },] },
    ];
    /** @nocollapse */
    PrettyJsonModule.ctorParameters = function () { return []; };
    return PrettyJsonModule;
}());
//# sourceMappingURL=prettyjson.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-prettyjson/src/prettyjson.module.js
// module id = 744
// module chunks = 4